import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dextEmailViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map